import { React, useState } from "react";
import Nuova from "../imgs/Nuova orchestra.jpeg";
import Orchestra from "../imgs/Galleria/Immagini nuova orchestra (1).webp";
import Orchestra2 from "../imgs/Galleria/Immagini nuova orchestra (2).webp";
import { FaMusic, FaUserTie } from "react-icons/fa";
import { GiMusicalNotes } from "react-icons/gi";

const NuovaOrchestra = () => {
  const [fullScreenImage, setFullScreenImage] = useState(null);

  const handleImageClick = (img) => setFullScreenImage(img);
  const closeImage = () => setFullScreenImage(null);
  return (
    <div className="px-4 md:px-8 pb-16 flex flex-col items-center w-full bg-gradient-to-r from-white to-amber-50 text-gray-800">
      <GiMusicalNotes className="fixed text-amber-200/40 text-[180px] rotate-12 -top-5 -right-5 z-0" />
      {/* Titolo */}
      <h1 className="text-red-600 font-extrabold text-2xl md:text-4xl mt-5 tracking-wide mb-10 z-10">
        NUOVA ORCHESTRA DI MILANO
      </h1>

      {/* Sezione immagini */}
      <div className="w-full md:w-2/3 lg:w-1/2 mb-12 z-10 flex flex-col items-center gap-8 px-4">
        <img
          src={Nuova}
          alt="Logo Nuova Orchestra"
          className="w-32 md:w-48 opacity-90 rounded-xl shadow-md object-contain"
        />

        <img
          src={Orchestra}
          alt="Orchestra"
          className="w-3/4 md:w-2/3 rounded-2xl shadow-xl hover:scale-[1.03] transition-transform duration-300 object-contain"
          onClick={() => handleImageClick(Orchestra)}
        />
        <img
          src={Orchestra2}
          alt="Orchestra2"
          className="w-4/5 md:w-3/4 rounded-2xl shadow-xl hover:scale-[1.03] transition-transform duration-300 object-cover"
          onClick={() => handleImageClick(Orchestra2)}
        />
      </div>
      {fullScreenImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
          onClick={closeImage}
        >
          <img
            src={fullScreenImage}
            alt="Full screen"
            className="max-w-[90vw] max-h-[90vh] rounded-2xl shadow-2xl"
          />
        </div>
      )}

      {/* Direttore */}
      <div className="flex flex-col items-center text-center bg-white rounded-2xl shadow-lg p-6 md:p-10 mb-12 w-full md:w-3/4 lg:w-2/3  z-10">
        <FaUserTie className="text-red-600 text-3xl mb-3" />
        <p className="text-xl font-semibold mb-2">
          Direttore:{" "}
          <a
            href="https://www.giuseppedinardo.it/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-red-600 hover:underline"
          >
            Giuseppe Dinardo
          </a>
        </p>
      </div>

      {/* Membri orchestra */}
      <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 w-full md:w-4/5 lg:w-2/3 mb-16  z-10">
        <div className="flex items-center justify-center mb-6">
          <FaMusic className="text-red-600 text-2xl mr-2" />
          <h2 className="text-2xl font-bold text-gray-900">
            Membri dell’Orchestra
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 text-base text-gray-700  ">
          {[
            [
              "Violini",
              "Francesco Di Giacinto, Teresa Lombardi, Rossella Serino, Mariangela Franco Montelli, Simonetta Sargenti, Anna Lombardi",
            ],
            [
              "Viole",
              "Svitlana Fedorova, Sabrina Semeraro, Rosaria Mastrosimone",
            ],
            [
              "Violoncelli",
              "Luca Russo Rossi, Annalisa Di Leo, Elisa Missaglia",
            ],
            ["Contrabbassi", "Vito Tagliente, Sergio Fiacconi"],
            ["Flauti", "Chiara Brunelli, Chiara Pasqualini, Lidia Savoia"],
            ["Oboi", "Alessandro Nardi, Imma Mincolla"],
            [
              "Clarinetti",
              "Francesco Silipigni, Alessio Quaglia, Mario Montani",
            ],
            ["Fagotto", "Domenico Serrecchia"],
            ["Corni", "Ana Abramovic, Federico Ceccarelli"],
            ["Trombe", "Raffaele Quaranta, Desario Ruggero"],
            ["Tromboni", "Ilario Roccisano, Antonio Rizzuto"],
            ["Timpani", "Roberto Manclossi"],
            ["Percussioni", "Paolo Mogni, Papanikolaou Stavros"],
            ["Arpa", "Maria Pistone"],
          ].map(([section, names], index) => (
            <div
              key={index}
              className="bg-amber-50 rounded-xl p-4 shadow-sm hover:shadow-md transition-all duration-300"
            >
              <strong className="font-extrabold text-red-600">{section}</strong>
              <p className="mt-1 text-gray-700">{names}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Testo descrittivo */}
      <div className="w-full md:w-4/5 lg:w-2/3 text-center text-gray-700 space-y-8 leading-relaxed bg-white/70 backdrop-blur-sm p-8 md:p-12 rounded-2xl shadow-md  z-10">
        <p>
          In un periodo storico in cui molte orchestre hanno dovuto chiudere i
          battenti, <strong>MilARTE</strong> ha deciso di affrontare con
          determinazione questa sfida culturale. L’orchestra si ispira alle
          prestigiose formazioni internazionali, diventando un luogo di
          aggregazione che celebra la bellezza del <em>“Fare Musica”</em> e
          promuove la sensibilità artistica e sociale.
        </p>
        <p>
          La <strong>Nuova Orchestra di Milano</strong> accoglie musicisti
          professionisti e semiprofessionisti che vogliono esprimere il proprio
          talento all’interno di un contesto orchestrale ricco di creatività e
          collaborazione. Un ambiente in cui le passioni musicali si uniscono
          alla crescita personale e artistica.
        </p>
        <p>
          Questo progetto, di grande valore culturale ed educativo, allinea
          Milano a un modello di vita musicale basato su socialità,
          corresponsabilità e innovazione, aprendosi a collaborazioni con altre
          città, università, teatri e scuole di musica.
        </p>
      </div>
    </div>
  );
};

export default NuovaOrchestra;
